import * as Yup from 'yup';
import { PAYMENT_TYPE } from 'src/models/PaymentModel';
import { t } from './language';

const isOnlinePayment = (
  type: PAYMENT_TYPE,
) => [PAYMENT_TYPE.cc, PAYMENT_TYPE.eft].includes(type);

// const isOfflinePayment = (
//   type: PAYMENT_TYPE,
// ) => ![PAYMENT_TYPE.cc, PAYMENT_TYPE.eft].includes(type);

export const onlinePaymentIdField = (
  lang: string,
) => Yup.number()
  .when('payment_type', {
    is: (value: PAYMENT_TYPE) => isOnlinePayment(value),
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.nullable(),
  })
  .min(1, t(lang, 'validations.invoice.field_required'))
  .integer();

export const moneyField = () => Yup.mixed().test(
  'is-money',
  'Value must be a valid monetary amount',
  (value) => {
    if (value === undefined || value === null) {
      return true;
    }
    if (typeof value === 'number') {
      return Number.isFinite(value) && value >= 0 && /^\d+(\.\d{1,2})?$/.test(value.toString());
    }
    if (typeof value === 'string') {
      return /^\d+(\.\d{1,2})?$/.test(value);
    }
    return false;
  },
);

export const slugField = () => Yup.string()
  .matches(
    /^(?!-)[a-z0-9-]+(?<!-)$/,
    'Slug can only contain lowercase letters, numbers, and hyphens, and cannot start or end with a hyphen',
  )
  .test(
    'no-consecutive-hyphens',
    'Slug cannot contain consecutive hyphens',
    (value) => !value || !/--/.test(value),
  );

export const isValidIdRequired = (value: unknown): boolean => {
  const num = typeof value === 'string' ? Number(value) : value;
  return typeof num === 'number' && Number.isInteger(num) && num > 0;
};
export const idFieldRequired = () => Yup.mixed().test(
  'is-id',
  'Value need to be set',
  isValidIdRequired,
);

export const isValidId = (value: unknown): boolean => {
  if (value == null) return true;
  const num = typeof value === 'string' ? Number(value) : value;
  return typeof num === 'number' && Number.isInteger(num) && num > 0;
};

export const idField = () => Yup.mixed().test(
  'is-id',
  'Value need to be set',
  isValidId,
);

// Require organisation_id if no contact_id is set
export const needOrganisationIdField = (lang: string) => Yup.string()
  .nullable()
  .when('contact_id', {
    is: (contactId: unknown) => !contactId,
    then: (schema) => schema.required(t(lang, 'validations.contact.required_if_no_contact_id')),
    otherwise: (schema) => schema.nullable(),
  });

// Require contact_id if no organisation_id is set
export const needContactIdField = (lang: string) => Yup.string()
  .nullable()
  .when('organisation_id', {
    is: (organisationId: unknown) => !organisationId,
    then: (schema) => schema.required(t(lang, 'validations.contact.required_if_no_organisation_id')),
    otherwise: (schema) => schema.nullable(),
  });
